import { useRouter } from 'hooks/useRouter'

export const useTeamMemberSidebarNavigation = () => {
  const router = useRouter()

  const getLastUrlKey = () => router.location.pathname.split('/').slice(-1)[0]

  const lastUrlKey = getLastUrlKey()

  const defaultSelectedKey = lastUrlKey
  return { defaultSelectedKey }
}
